import { useTranslation } from 'react-i18next';

export function Forbidden() {
  const { t } = useTranslation('common');
  return (
    <section className="mx-auto grid max-w-md gap-3 p-6 text-center">
      <h1 className="text-2xl font-semibold">{t('auth.forbidden.title')}</h1>
      <p className="text-muted-foreground text-sm">{t('auth.forbidden.body')}</p>
    </section>
  );
}
